/**
 * Determine whether an object is a 'pending' atom
 * @param {*} value The object to test
 * @return {boolean} Whether the object is a 'pending' atom
 */
function isPending(value) {
  return Boolean(value) && (value.$type === 'pending');
}

module.exports = isPending;
